import { useQuery } from "@tanstack/react-query";
import useRevenue from "../utils/useRevenue";

export default function useAggregatedSalesData(
  start_date,
  end_date,
  period,
  collection_id,
  enabled
) {
  const { getAggregatedSales } = useRevenue();

  const { data, isLoading, error } = useQuery({
    queryKey: [
      "aggregatedSalesData",
      start_date,
      end_date,
      period,
      collection_id,
    ],
    queryFn: async () => {
      try {
        const response = await getAggregatedSales({
          start_date,
          end_date,
          period,
          collection_id,
        });
        if (!response?.data) {
          throw new Error("Dados inválidos retornados pela API");
        }

        const formattedData = {
          labels: response.data.labels || [],
          data: response.data.data || [],
        };

        return { data: formattedData };
      } catch (error) {
        console.error("Erro ao buscar dados de faturamento:", error);
        throw error;
      }
    },
    enabled,
  });

  return {
    data: data?.data,
    isLoading,
    error,
  };
}
